import {
  LayoutDashboard,
  BookOpen,
  BarChart3,
  Brain,
  Wallet,
  Sparkles,
  DollarSign,
  HelpCircle,
  Timer,
  Building2,
  FileText,
  GraduationCap,
  Handshake,
} from "lucide-react";
import { routes } from "wasp/client/router";
import type { NavigationItem } from "./NavBar";
import type { Translations } from "../../i18n/translations";
import type { LucideIcon } from "lucide-react";

export interface NavigationItemWithIcon extends NavigationItem {
  icon: LucideIcon;
}

const MENTOR_PLANS = new Set(["pro", "proAnnual", "max", "maxAnnual"]);

export const getMarketingNavigationItems = (t: Translations): NavigationItemWithIcon[] => [
  { name: t.nav.features, to: "#features", icon: Sparkles },
  { name: t.nav.pricing, to: "#pricing", icon: DollarSign },
  { name: t.nav.faq, to: "#faq", icon: HelpCircle },
  { name: t.nav.blog, to: "/blog", icon: BookOpen },
];

export interface MegaMenuEntry {
  key: string;
  label: string;
  desc: string;
  to: string;
}

export const getMarketingMegaMenus = (t: Translations): {
  features: MegaMenuEntry[];
  solutions: MegaMenuEntry[];
} => ({
  features: [
    { ...t.marketing.nav.megaFeatures[0], to: "/journal-de-trading" },
    { ...t.marketing.nav.megaFeatures[1], to: "/fonctionnalites/prop-firm-manager" },
    { ...t.marketing.nav.megaFeatures[2], to: "/fonctionnalites/analytics-trading" },
    { ...t.marketing.nav.megaFeatures[3], to: "/fonctionnalites/sessions-de-trading" },
    { ...t.marketing.nav.megaFeatures[4], to: "/fonctionnalites/mode-mentor" },
    { ...t.marketing.nav.megaFeatures[5], to: "/fonctionnalites/dashboard-trading" },
    { ...t.marketing.nav.megaFeatures[6], to: "/integrations" },
  ],
  solutions: [
    { ...t.marketing.nav.megaSolutions[0], to: "/solutions/prop-trader-debutant" },
    { ...t.marketing.nav.megaSolutions[1], to: "/solutions/prop-trader-multi-comptes" },
    { ...t.marketing.nav.megaSolutions[2], to: "/solutions/coach-trading" },
  ],
});

export const getDemoNavigationItems = (
  t: Translations,
  user?: { subscriptionPlan: string | null } | null,
  hasAffiliateProfile?: boolean,
): NavigationItemWithIcon[] => {
  const canUseMentor =
    user != null && user.subscriptionPlan != null && MENTOR_PLANS.has(user.subscriptionPlan);

  const items: NavigationItemWithIcon[] = [
    { name: t.nav.dashboard, to: routes.TradingDashboardRoute?.to || "/dashboard", icon: LayoutDashboard },
    { name: t.nav.propFirmManager, to: routes.PropFirmManagerRoute?.to || "/prop-firm-manager", icon: Building2 },
    { name: t.nav.journal, to: routes.TradingJournalRoute?.to || "/trading-journal", icon: BookOpen },
    { name: t.nav.analytics, to: routes.TradingAnalyticsRoute?.to || "/trading-analytics", icon: BarChart3 },
    { name: t.nav.sessions, to: routes.TradingSessionsRoute?.to || "/trading-sessions", icon: Timer },
    { name: t.nav.accounts, to: routes.TradingAccountsRoute?.to || "/trading-accounts", icon: Wallet },
    { name: t.nav.disciplineManager, to: routes.DisciplineManagerRoute?.to || "/discipline-manager", icon: Brain },
    { name: t.nav.reports, to: routes.ReportsRoute?.to || "/reports", icon: FileText },
    { name: t.edgy.history.navLabel, to: routes.EdgyReportsRoute?.to || "/my-analyses", icon: Sparkles },
  ];

  if (canUseMentor) {
    items.push({
      name: t.nav.mentor,
      to: "/mentor",
      icon: GraduationCap,
    });
  }

  // Entrée visible uniquement pour les ambassadeurs (profil d'affiliation actif)
  if (hasAffiliateProfile) {
    items.push({
      name: t.nav.affiliate,
      to: "/affiliate",
      icon: Handshake,
    });
  }

  return items;
};
